import MarkdownIt from 'markdown-it'

export default function getHTMLfromContent(content) {
  const htmlTagRegex = /<.+?>/g
  const boldRegex = /(\*+)(.*?)( *)(\*+)/g
  content = content.replace(boldRegex, '$1$2$4$3')
  const italicRegex = /(_+)(.*?)( ?)(_+)/g
  content = content.replace(italicRegex, ' $1$2$4$3')
  let matches = content.match(htmlTagRegex) || []
  let hasHTMLtags = matches.length > 0
  let md = new MarkdownIt()
  if (!hasHTMLtags) {
    content = md.render(content)
  }
  return content
}
